var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"leftSideBar"}},[_c('p',{attrs:{"hidden":""}},[_c('span',{staticClass:"getCurrent"},[_vm._v(_vm._s(_vm.current))]),_c('span',{staticClass:"leftIndex"},[_vm._v(_vm._s(_vm.leftIndex))])]),_c('ul')])
}
var staticRenderFns = []

export { render, staticRenderFns }